import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { ExecucaoOrcamentaria } from '../../models/execucao-orcamentaria.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { AtualizacoesAuditService } from '../../services/atualizacoes-audit.service';
import { ExecucaoOrcamentariaService } from '../../services/execucao-orcamentaria.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-detalhe-projeto-execucao-orcamentaria-config',
  templateUrl: './detalhe-projeto-execucao-orcamentaria-config.component.html',
  styleUrls: ['./detalhe-projeto-execucao-orcamentaria-config.component.scss']
})
export class DetalheProjetoExecucaoOrcamentariaConfigComponent extends BaseFormComponent<ExecucaoOrcamentaria> implements OnInit, OnDestroy {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  @Input() idExecucao: number;
  list: any;
  permission: any;
  listAudit: AtualizacoesAudit[];

  constructor(
    private myService: ExecucaoOrcamentariaService,
    private auditService: AtualizacoesAuditService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private pesquisaGeralService: PesquisaGeralService,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      
      this.initForm();
      this.initList();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList() {
    this.loading();
    this.permission = this.activatedRoute.snapshot.data['permission'];
    this.listAudit = this.activatedRoute.snapshot.data['audit'];
    this.addSub(
      this.myService.getConfigList(this.idExecucao).subscribe({
        next: (res) => {
          this.list = res?.type_list;
          this.form.get('tipo_integracao').setValue(String(res?.tipo_integracao))
          this.loaded();
        },
        error: (err) => {
          this.loaded();
        },
      })
    )
  }

  initForm() {
    this.form = new FormGroup({
      tipo_integracao: new FormControl(null, [Validators.required]),
    });
  }

  getDataCreate(): ExecucaoOrcamentaria {
    let data: ExecucaoOrcamentaria;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.idExecucao) {
        this.addSub(
          this.myService.configUpdate(this.getDataCreate(), this.idExecucao).subscribe({
            next: (res) => {
              EventSharedService.get('reloadPermission').emit(res);
              this.auditRefresh();
              this.msgSuccess('Execução Orçamentaria alterada com sucesso!');
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir() {
    this.loading();
    this.myService.delete(this.idExecucao).subscribe({
      next: (res) => {
        this.loaded();
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'execucao-orcamentaria']);
        });
      },
      error: (error) => {
        this.msgError(error.error?.message);
        this.loaded();
      }
    });
  }

  auditRefresh(){
    let audit = {
      budget_id: this.idExecucao,
      budget_assoc_fpe_id: this.idExecucao,
    };

    this.addSub(
      this.auditService.getAtualizacoes(audit).subscribe((res)=>{
        this.listAudit = res;
        EventSharedService.get('auditRefresh').emit(res);
      })
    );
  }
}
